module.exports = __webpack_public_path__ + "assets/details-switzerland.b0029d18.svg";